import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrInfoTooltipComponent } from './tr-info-tooltip.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [CommonModule, SvgIconModule],
    declarations: [TrInfoTooltipComponent],
    exports: [TrInfoTooltipComponent],
})
export class TrInfoTooltipModule {}
